import React from "react";
import { Link } from "react-router-dom";

import { GROUNDLIGHT_SUPPORT_EMAIL, SDK_DOCS_URL } from "config/constants";
import { Typography } from "new-components/typography/Typography";
import { TierType } from "types/users";

import { PerkInfo, stepsContentProps } from "./types";

const step1 = `${process.env.PUBLIC_URL}/static/stepIcons/step1.svg`;
const step2 = `${process.env.PUBLIC_URL}/static/stepIcons/step2.svg`;
const step3 = `${process.env.PUBLIC_URL}/static/stepIcons/step3.webp`;
const step4 = `${process.env.PUBLIC_URL}/static/stepIcons/new-step4.svg`;

export const TIER_TYPE_TO_PERK_INFO: Partial<Record<TierType, PerkInfo>> = {
  [TierType.Free]: {
    title: "Free",
    monthlyCost: 0,
    perks: [
      "1,000 Image Queries",
      "50 Cloud Labels Included /mo",
      "Reduced Cloud Labeling priority",
      "Limit of 3 Active Detectors",
    ],
  },
  [TierType.Paid_1]: {
    title: "Pro",
    monthlyCost: 149,
    perks: [
      "10,000 Image Queries",
      "500 Cloud Labels Included /mo",
      "Standard Overage Rate: $19 per additional 1k Queries & 50 Cloud Labels",
      "Limit of 5 Active Detectors",
    ],
  },
  [TierType.Paid_2]: {
    title: "Business",
    monthlyCost: 399,
    perks: [
      "25,000 Image Queries",
      "1,500 Cloud Labels Included /mo",
      "Discounted Overage Rate: $17 per additional 1k Queries & 60 Cloud Labels",
      "Limit of 15 Active Detectors",
    ],
  },
};

export const INITIAL_STEPS: stepsContentProps = [
  {
    title: "Welcome!",
    image: <img src={step1} className="w-full object-contain max-h-64" alt="charged img" />,
    content: (
      <Typography>
        Groundlight answers plain English questions about real-world images. We build customized, human-supervised AI
        models which seamlessly integrate into your existing business logic.
      </Typography>
    ),
  },
];

export const FINAL_STEPS = [
  {
    title: "Need some help?",
    image: <img src={step2} className="w-full object-contain max-h-64" alt="charged img" />,
    content: (
      <Typography mb={2}>
        We&apos;re here for you! Email us at{" "}
        <a href={`mailto:${GROUNDLIGHT_SUPPORT_EMAIL}`} className="text-primary-bright">
          {GROUNDLIGHT_SUPPORT_EMAIL}
        </a>
        .
      </Typography>
    ),
  },
  {
    title: "Documentation",
    image: <img src={step3} className="w-full object-contain max-h-64" alt="charged img" />,
    content: (
      <Typography>
        From getting started to fully custom installations, we’ve got you covered. Explore{" "}
        <a
          href={SDK_DOCS_URL}
          target="_blank"
          rel="noreferrer"
          className="text-primary-bright underline"
        >
          code.groundlight.ai
        </a>{" "}
        for info and examples of how to configure Groundlight to perfectly suit your application.
      </Typography>
    ),
  },
  {
    title: "Try it out with DEMO",
    image: <img src={step4} className="w-full object-contain max-h-64" alt="charged img" />,
    content: (
      <Typography>
        Test out how a Groundlight detector works using your webcam with the{" "}
        <Link to="/reef/quickstart" className="text-primary-bright uppercase">
          DEMO
        </Link>{" "}
        page. When you’re ready, install the Groundlight SDK and generate an API token to access the complete service.
      </Typography>
    ),
  },
];
